module.exports = __webpack_public_path__ + "img/neon-wave.f59165fb.png";